import { render } from "./UserGoals.vue?vue&type=template&id=4a9a83b6&scoped=true"
import script from "./UserGoals.vue?vue&type=script&lang=js"
export * from "./UserGoals.vue?vue&type=script&lang=js"

import "./UserGoals.vue?vue&type=style&index=0&id=4a9a83b6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a9a83b6"]])

export default __exports__